'use strict';

var jQuery = require('jquery');
var MultiSelectComboboxVirtualScrollingHelper = function MultiSelectComboboxVirtualScrollingHelper(multiSelectComboboxService) {
  var checkedClass = 'checked';
  var activeClass = 'active';
  var disabledClass = 'disabled';
  var dropDownElementsQuantity = 6;
  var listItemSize = 30;
  var listWrapperHeight = 140;
  var VisibleDataItem = function VisibleDataItem(domElement) {
    this.text = '';
    this.y = null;
    this.checked = false;
    this.active = false;
    this.visible = true;
    this.domElement = domElement;
    //original data of the item;
    this.data = null;
    this.activeElement = null;
    this.firstVisibleItemIndex = 0;
  };
  var listItemTemplate = jQuery('<li class="rm-multi-dropdown-item"></li>');
  var Helper = function Helper(scrollContainer, clickHandler, mouseOverHandler, mouseOutHandler, listItemHeight) {
    this.clickHandler = clickHandler;
    this.mouseOverHandler = mouseOverHandler;
    this.mouseOutHandler = mouseOutHandler;
    this.scrollContainer = scrollContainer;
    this.listItemSize = listItemHeight || listItemSize;
    this.scrollTopValue = 0;
    this.ulElement = this.scrollContainer.find('ul');
    this.ulHeight = 0;
    this.data = [];
    this.visibleData = [];
    this.initializeVisibleElements();
    var that = this;
    this.scrollContainer.on('scroll', function () {
      that.scrollTopValue = that.scrollContainer.scrollTop();
      that.showData();
    });
  };
  Helper.prototype.initializeVisibleElements = function () {
    for (var i = 0; i < dropDownElementsQuantity; i++) {
      var listElement = listItemTemplate.clone(true, true);
      listElement.on('click', this.onClickHandler.bind(this, i));
      listElement.hover(this.onMouseOver.bind(this, i), this.onMouseOut.bind(this, i));
      this.ulElement.append(listElement);
      this.visibleData.push(new VisibleDataItem(listElement));
    }
  };
  Helper.prototype.onClickHandler = function (index) {
    var item = this.visibleData[index];
    item.data.selected = !item.checked;
    this.clickHandler(item.data, true);
  };
  Helper.prototype.onMouseOver = function (index) {
    var visibleDataElement = this.visibleData[index];
    visibleDataElement.domElement.addClass(activeClass);
    visibleDataElement.active = true;
    var prevActiveElement = this.visibleData[this.activeElementIndex];
    if (prevActiveElement) {
      prevActiveElement.domElement.removeClass(activeClass);
    }
    this.activeElementIndex = this.firstVisibleItemIndex + index;
  };
  Helper.prototype.onMouseOut = function (index) {
    var visibleDataElement = this.visibleData[index];
    visibleDataElement.active = false;
    visibleDataElement.domElement.removeClass(activeClass);
    this.activeElementIndex = -1;
  };
  Helper.prototype.setActiveElementByIndex = function (nextIndex) {
    this.activeElementIndex = nextIndex;
    var activeElementPosition = nextIndex * this.listItemSize;
    var scroll = multiSelectComboboxService.getScrollValue(this.scrollTopValue, listWrapperHeight, activeElementPosition, this.listItemSize);
    if (scroll !== null) {
      this.scrollTopValue = scroll;
      this.scrollTo(scroll);
    }
    this.showData();
  };
  Helper.prototype.setNextActiveElement = function () {
    var nextIndex = multiSelectComboboxService.getNextElementIndex(this.activeElementIndex, this.data) || 0;
    this.setActiveElementByIndex(nextIndex);
  };
  Helper.prototype.setPrevActiveElement = function () {
    var nextIndex = multiSelectComboboxService.getPrevElementIndex(this.activeElementIndex, this.data);
    this.setActiveElementByIndex(nextIndex);
  };
  Helper.prototype.selectActiveElement = function () {
    var visibleDataActElemIndex = this.activeElementIndex - this.firstVisibleItemIndex;
    var activeElement = this.visibleData[visibleDataActElemIndex];
    if (activeElement) {
      activeElement.data.selected = !activeElement.checked;
      this.clickHandler(activeElement.data);
    }
  };
  Helper.prototype.scrollTo = function (value) {
    this.scrollContainer.scrollTop(value);
  };
  Helper.prototype.setScrollContainerSize = function () {
    this.ulHeight = this.data.length * this.listItemSize;
    this.ulElement.height(this.ulHeight);
  };
  Helper.prototype.updateVisibleElement = function (visibleItem, data, newPosition, active) {
    visibleItem.data = data;
    if (visibleItem.text !== visibleItem.data.dropdownVisibleValue) {
      visibleItem.text = visibleItem.data.dropdownVisibleValue;
      visibleItem.domElement.text(visibleItem.text);
    }
    if (visibleItem.data.originalData && visibleItem.data.originalData.assigned) {
      visibleItem.domElement.find('span.message').remove();
      visibleItem.domElement.append('<span class="message"></span>');
      visibleItem.message = '';
      if (visibleItem.data.selected) {
        visibleItem.message = visibleItem.data.originalData.assignedWarningmessage;
      } else {
        visibleItem.message = visibleItem.data.originalData.assignedMessage;
      }
      visibleItem.domElement.find('span.message').toggleClass('warning', visibleItem.data.selected);
      visibleItem.domElement.find('span.message').text(visibleItem.message);
    }
    if (visibleItem.checked !== visibleItem.data.selected) {
      visibleItem.checked = visibleItem.data.selected;
      visibleItem.domElement.toggleClass(checkedClass, visibleItem.data.selected);
    }
    if (visibleItem.disabled !== visibleItem.data.disabled) {
      visibleItem.disabled = visibleItem.data.disabled;
      visibleItem.domElement.toggleClass(disabledClass, visibleItem.data.disabled);
    }
    if (visibleItem.active !== active) {
      visibleItem.active = active;
      visibleItem.domElement.toggleClass(activeClass, active);
    }
    if (!visibleItem.visible) {
      visibleItem.domElement.removeClass('hidden');
      visibleItem.visible = true;
    }
    if (visibleItem.x !== newPosition) {
      visibleItem.domElement.css('top', newPosition);
      visibleItem.x = newPosition;
    }
  };
  Helper.prototype.showData = function () {
    var visiblePart = this.scrollTopValue / this.listItemSize;
    this.firstVisibleItemIndex = Math.floor(visiblePart);
    var visibleData = this.data.slice(this.firstVisibleItemIndex, dropDownElementsQuantity + this.firstVisibleItemIndex);
    var visibleDataActElemIndex = this.activeElementIndex - this.firstVisibleItemIndex;
    var firstItemY = this.firstVisibleItemIndex * this.listItemSize;
    for (var i = 0; i < dropDownElementsQuantity; i++) {
      var data = visibleData[i];
      var visibleItem = this.visibleData[i];
      if (data) {
        var active = i === visibleDataActElemIndex;
        var newPosition = firstItemY + this.listItemSize * i;
        this.updateVisibleElement(visibleItem, data, newPosition, active);
      } else {
        if (visibleItem.visible) {
          visibleItem.domElement.addClass('hidden');
          visibleItem.visible = false;
        }
      }
    }
  };
  Helper.prototype.render = function (data) {
    this.activeElementIndex = -1;
    this.data = data;
    this.scrollTopValue = 0;
    this.setScrollContainerSize();
    this.scrollTo(this.scrollTopValue);
    this.showData();
  };
  Helper.prototype.destroy = function () {
    if (this.ulElement && this.ulElement.empty) {
      this.ulElement.empty();
    }
    this.ulElement = null;
    for (var i = 0; i < this.visibleData.length; i++) {
      if (this.visibleData[i].domElement && this.visibleData[i].domElement.remove) {
        this.visibleData[i].domElement.remove();
      }
      this.visibleData[i].domElement = null;
    }
  };
  Helper.prototype.disableElements = function (selected) {
    var checkForSelected = false;
    var dataLength = this.data.length;
    if (typeof selected === 'boolean') {
      checkForSelected = true;
    }
    for (var i = 0; i < dataLength; i++) {
      var current = this.data[i];
      current.disabled = checkForSelected && current.selected === selected || !checkForSelected;
    }
  };
  Helper.prototype.enableElements = function (selected) {
    var checkForSelected = false;
    var dataLength = this.data.length;
    if (typeof selected === 'boolean') {
      checkForSelected = true;
    }
    for (var i = 0; i < dataLength; i++) {
      var current = this.data[i];
      current.disabled = !(checkForSelected && current.selected === selected || !checkForSelected);
    }
  };
  return Helper;
};
MultiSelectComboboxVirtualScrollingHelper.$inject = ['MultiSelectComboboxService'];
module.exports = MultiSelectComboboxVirtualScrollingHelper;